"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logWarning = exports.logError = void 0;
const LOG_PREFIX = 'script-supplier:';
const logWarning = function (message) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }
  console.warn(`${LOG_PREFIX} ${message}`, ...rest);
};
exports.logWarning = logWarning;
const logError = function (message) {
  for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    rest[_key2 - 1] = arguments[_key2];
  }
  console.error(`${LOG_PREFIX} ${message}`, ...rest);
};
exports.logError = logError;